import { translate } from "@/i18n/translate";

/**
 * Photo-quality check filter of the pizza list: option value -> Mongo condition on the stored evaluation.
 * "blur_shadow" finds photos the blur check would reject while it runs in shadow mode
 * (blur_check_enforce=false in pizza-backend), i.e. with the check status still OK.
 */
export const PHOTO_QUALITY_CHECK_CONDITIONS: Record<string, Record<string, unknown>> = {
  blur: { "evaluation.metadata.photo_quality_evaluation.checks.pizza_blur.status": "NOK" },
  blur_shadow: {
    "evaluation.metadata.photo_quality_evaluation.checks.pizza_blur.details.would_fail": true,
  },
  obstacle: { "evaluation.metadata.photo_quality_evaluation.checks.obstacle_in_pizza.status": "NOK" },
  visibility: { "evaluation.metadata.photo_quality_evaluation.checks.pizza_visibility.status": "NOK" },
};

/** Options of the filter in the current language (labels shared with the photo-quality reasons). */
export const getPhotoQualityCheckOptions = () => [
  { label: translate("photoReason.pizza_blurred"), value: "blur" },
  {
    label: translate("pizzas.filters.shadowMode", { check: translate("photoReason.pizza_blurred") }),
    value: "blur_shadow",
  },
  { label: translate("photoReason.obstacle_in_pizza_detected"), value: "obstacle" },
  { label: translate("photoReason.pizza_visibility_below_threshold"), value: "visibility" },
];
